/** Shared Recharts tooltip — dark card readable on light Ember analytics pages. */
export const chartTooltipContentStyle = {
  backgroundColor: "rgba(15, 23, 42, 0.96)",
  border: "1px solid #cbd5e1",
  borderRadius: "8px",
  color: "#f8fafc",
  fontSize: "12px",
  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.2)",
};

export const chartTooltipLabelStyle = { color: "#f8fafc", fontWeight: 600 };

export const chartTooltipItemStyle = { color: "#e2e8f0" };

export function chartTooltipProps(extra = {}) {
  return {
    contentStyle: chartTooltipContentStyle,
    labelStyle: chartTooltipLabelStyle,
    itemStyle: chartTooltipItemStyle,
    ...extra,
  };
}
